export const M6_READING_PRACTICE = {
  id: "m6-final-reading",
  title: "Module 6 Final Reading - Real World English",
  topic: "Five different real-world reading passages integrating everything you've learned! 🌍📚",
  iconType: "book-open",
  
  sets: [
    // ============================================
    // SET 1: INTERNATIONAL STUDENT PROFILE
    // ============================================
    {
      id: "m6-final-reading-s1",
      title: "Set 1: Student Exchange Program",
      category: "reading",
      passages: [
        {
          text: `STUDENT PROFILE: Sofia Martinez

Sofia is a 22-year-old student from Argentina. She's from Buenos Aires, the capital city on the southeast coast of the country. Sofia is studying International Business at the University of Toronto in Canada, in the east of North America. She arrived in Canada on September 15th, 2023, and will complete her program on June 30th, 2025.

Sofia chose Toronto because it's a multicultural city with students from over 180 countries. Approximately 45% of Toronto's population was born outside Canada. The city is on the north shore of Lake Ontario, right next to the United States border.`,
          questions: [
            {
              type: "mc",
              q: "Where is Sofia from?",
              options: ["Buenos Aires, Argentina", "Toronto, Canada", "Lake Ontario"],
              a: "Buenos Aires, Argentina",
              tip: "First paragraph states her origin!"
            },
            {
              type: "mc",
              q: "Buenos Aires is on the ___ coast of Argentina.",
              options: ["northeast", "southeast", "northwest"],
              a: "southeast",
              tip: "Text says 'southeast coast of the country'!"
            },
            {
              type: "input",
              q: "What is Sofia's nationality?",
              a: ["Argentine", "argentine", "Argentinian", "argentinian", "Argentinean", "argentinean"],
              tip: "Someone from Argentina is Argentine/Argentinian!"
            },
            {
              type: "mc",
              q: "When did Sofia arrive in Canada?",
              options: ["September 15, 2023", "June 30, 2025", "September 15, 2025"],
              a: "September 15, 2023",
              tip: "First paragraph mentions arrival date!"
            }
          ]
        },
        {
          text: `During her time in Toronto, Sofia lives at 456 College Street, apartment 12B, Toronto, ON M5T 1R5. Her Canadian phone number is +1 416-555-3892 (that's country code plus four-one-six, triple five, three-eight-nine-two). She can also be reached by email at sofia.martinez99@university.ca.

Sofia's schedule is busy. Classes run Monday to Friday from 9:00 AM to 3:30 PM, with a lunch break from 12:00 PM to 1:00 PM. She works part-time at a café on weekends from half past ten in the morning until 5:00 PM. Despite her busy schedule, Sofia has made friends from Japan, Nigeria, and Brazil - truly an international experience!`,
          questions: [
            {
              type: "input",
              q: "What is Sofia's house number?",
              a: ["456"],
              tip: "First line of second passage!"
            },
            {
              type: "mc",
              q: "What is Sofia's Canadian postal code?",
              options: ["M5T 1R5", "ON 456", "416-555"],
              a: "M5T 1R5",
              tip: "Canadian postcodes mix letters and numbers!"
            },
            {
              type: "mc",
              q: "How do you say @ in Sofia's email?",
              options: ["at", "arroba", "dot"],
              a: "at",
              tip: "@ is pronounced 'at' in English!"
            },
            {
              type: "input",
              q: "What time does Sofia's lunch break start?",
              a: ["12:00 PM", "12:00 pm", "12 PM", "twelve PM", "noon"],
              tip: "Schedule mentions lunch from 12:00 to 1:00!"
            },
            {
              type: "mc",
              q: "What time does Sofia start work on weekends?",
              options: ["9:00 AM", "10:30 AM", "12:00 PM"],
              a: "10:30 AM",
              tip: "Text says 'half past ten' = 10:30!"
            },
            {
              type: "mc",
              q: "Sofia has friends from Japan, Nigeria, and Brazil. How many different continents?",
              options: ["Two", "Three", "Four"],
              a: "Three",
              tip: "Japan (Asia), Nigeria (Africa), Brazil (South America) = 3 continents!"
            }
          ]
        }
      ]
    },

    // ============================================
    // SET 2: SPORTS EVENT STATISTICS
    // ============================================
    {
      id: "m6-final-reading-s2",
      title: "Set 2: International Marathon Results",
      category: "reading",
      passages: [
        {
          text: `THE CITY MARATHON 2024 - RACE REPORT

On Sunday, October 6th, 2024, the annual City Marathon took place in three locations simultaneously: Sydney (Australia), London (UK), and Vancouver (Canada). The race started at 7:00 AM local time in each city and the last runner crossed the finish line at 1:45 PM.

Over 15,000 runners participated - that's one and a half times more than last year's event. The demographics were impressive: 52% were male and 48% were female. Approximately three quarters (75%) of participants were between 25 and 40 years old. Runners came from 67 different countries, with the largest groups from the UK (30%), Australia (25%), Canada (20%), and other countries (25%).`,
          questions: [
            {
              type: "mc",
              q: "When did the marathon take place?",
              options: ["October 6, 2024", "October 16, 2024", "September 6, 2024"],
              a: "October 6, 2024",
              tip: "First paragraph gives the exact date!"
            },
            {
              type: "input",
              q: "What time did the race start?",
              a: ["7:00 AM", "7:00 am", "7 AM", "seven AM"],
              tip: "Same time in all three cities!"
            },
            {
              type: "mc",
              q: "How many runners participated?",
              options: ["10,000", "Over 15,000", "20,000"],
              a: "Over 15,000",
              tip: "Second paragraph states 'Over 15,000'!"
            },
            {
              type: "mc",
              q: "What fraction of participants were 25-40 years old?",
              options: ["One half", "Two thirds", "Three quarters"],
              a: "Three quarters",
              tip: "Text says 'three quarters (75%)'!"
            }
          ]
        },
        {
          text: `WINNING TIMES AND RECORDS

The men's race was won by Kipchoge Mwangi from Kenya with an incredible time of 2:08:34 (two hours, eight minutes, thirty-four seconds). He finished 2.5 minutes ahead of second place. The women's winner was Emma Wilson from the UK, completing the course in 2:24:17. Her time was just 0.45 minutes (or 27 seconds) slower than the course record.

Runner statistics showed that 82.5% of participants completed the full marathon distance of 42.195 kilometers. The remaining 17.5% chose the half-marathon option of 21.0975 kilometers - that's exactly half the distance. The average completion time was 4:15:00 (four hours and fifteen minutes), and 91% of finishers said they would participate again next year.`,
          questions: [
            {
              type: "input",
              q: "What is Kipchoge's nationality?",
              a: ["Kenyan", "kenyan"],
              tip: "Text says he's 'from Kenya'!"
            },
            {
              type: "mc",
              q: "Emma Wilson's time was 2:24:17. How do you say 0.45?",
              options: ["Zero point forty-five", "Zero point four five", "Zero comma four five"],
              a: "Zero point four five",
              tip: "Say each digit separately after the point!"
            },
            {
              type: "mc",
              q: "What percentage completed the full marathon?",
              options: ["75%", "82.5%", "91%"],
              a: "82.5%",
              tip: "Statistics paragraph mentions 82.5%!"
            },
            {
              type: "input",
              q: "The half-marathon is ___ km. (number only)",
              a: ["21.0975", "21,0975", "21.1", "21"],
              tip: "Text says 'half-marathon option of 21.0975'!"
            },
            {
              type: "mc",
              q: "What percentage said they'd participate again?",
              options: ["82.5%", "91%", "100%"],
              a: "91%",
              tip: "Last sentence: '91% of finishers said...'!"
            },
            {
              type: "mc",
              q: "The average completion time was 4:15:00. Another way to say 4:15?",
              options: ["Quarter past four", "Quarter to four", "Half past four"],
              a: "Quarter past four",
              tip: "4:15 = quarter past four = fifteen minutes after four!"
            }
          ]
        }
      ]
    },

    // ============================================
    // SET 3: CONFERENCE ANNOUNCEMENT
    // ============================================
    {
      id: "m6-final-reading-s3",
      title: "Set 3: Tech Conference 2025",
      category: "reading",
      passages: [
        {
          text: `GLOBAL TECH SUMMIT 2025
Innovation for Tomorrow

Date: March 20-22, 2025 (Thursday to Saturday)
Location: Singapore Expo, Hall 5
         10 Expo Drive, Singapore 486150
Time: 9:00 AM - 6:00 PM daily
Registration opens: January 15, 2025, at 8:00 AM SGT (Singapore Time)

The Global Tech Summit returns for its fifth year! This year's event takes place in Singapore, a city-state in Southeast Asia, right on the equator. Singapore is located on an island at the southern tip of the Malay Peninsula, between Malaysia (to the north) and Indonesia (to the south).

Early bird tickets (before February 1st): $450 USD
Regular tickets (February 1st - March 10th): $525 USD  
Late registration (after March 10th): $600 USD

That's a 25% discount for early birds compared to late registration!`,
          questions: [
            {
              type: "mc",
              q: "When does the conference take place?",
              options: ["January 15-17, 2025", "February 1-3, 2025", "March 20-22, 2025"],
              a: "March 20-22, 2025",
              tip: "Date listed at the top!"
            },
            {
              type: "input",
              q: "What time does registration open on January 15th?",
              a: ["8:00 AM", "8:00 am", "8 AM", "eight AM"],
              tip: "Registration section mentions 8:00 AM SGT!"
            },
            {
              type: "mc",
              q: "Singapore is located ___ Asia.",
              options: ["in Northeast", "in Southeast", "in Southwest"],
              a: "in Southeast",
              tip: "Text says 'Southeast Asia'!"
            },
            {
              type: "mc",
              q: "Singapore is ___ the Malay Peninsula.",
              options: ["in the north of", "at the southern tip of", "in the center of"],
              a: "at the southern tip of",
              tip: "Geographic description paragraph!"
            }
          ]
        },
        {
          text: `FEATURED SPEAKERS

Dr. Yuki Tanaka (Japanese, age 38) - AI Research Director
Based in: Tokyo, Japan (east coast of Honshu island)
Speaking on: March 20th at 10:30 AM - "The Future of Artificial Intelligence"
Contact: y.tanaka@airesearch.jp | +81 3 5555 0198

Maria Costa (Brazilian, age 33) - Cybersecurity Expert  
Based in: São Paulo, Brazil (southeast region, largest city in South America)
Speaking on: March 21st at 2:00 PM - "Protecting Digital Privacy"
Email: maria.costa@cybersafe.com.br | Phone: +55 11 9876 5432

James Park (Korean-Canadian, age 29) - Startup Founder
Based in: Vancouver, Canada (west coast, by the Pacific Ocean)
Speaking on: March 22nd at half past three - "Building Global Companies"
Website: www.startupglobal.io | Contact: james@startupglobal.io`,
          questions: [
            {
              type: "input",
              q: "What is Dr. Tanaka's nationality?",
              a: ["Japanese", "japanese"],
              tip: "Listed in parentheses after her name!"
            },
            {
              type: "mc",
              q: "When does Maria Costa speak?",
              options: ["March 20 at 10:30 AM", "March 21 at 2:00 PM", "March 22 at 3:30 PM"],
              a: "March 21 at 2:00 PM",
              tip: "Check Maria's speaking schedule!"
            },
            {
              type: "mc",
              q: "James Park speaks at 'half past three.' What time is that?",
              options: ["3:00 PM", "3:30 PM", "4:30 PM"],
              a: "3:30 PM",
              tip: "Half past three = 3:30!"
            },
            {
              type: "input",
              q: "How do you say the @ in Dr. Tanaka's email?",
              a: ["at", "At"],
              tip: "@ is always 'at' in English!"
            },
            {
              type: "mc",
              q: "Vancouver is on the ___ coast of Canada.",
              options: ["east", "west", "north"],
              a: "west",
              tip: "James Park section says 'west coast'!"
            },
            {
              type: "mc",
              q: "São Paulo is in the ___ of Brazil.",
              options: ["northeast", "southeast", "southwest"],
              a: "southeast",
              tip: "Maria's location says 'southeast region'!"
            },
            {
              type: "input",
              q: "What is James's website domain extension? (last 3 letters)",
              a: [".io", "io"],
              tip: "Website is www.startupglobal.io!"
            },
            {
              type: "mc",
              q: "Who is the youngest speaker?",
              options: ["Dr. Tanaka (38)", "Maria Costa (33)", "James Park (29)"],
              a: "James Park (29)",
              tip: "Compare ages: 38, 33, and 29!"
            }
          ]
        }
      ]
    },

    // ============================================
    // SET 4: MIGRATION STATISTICS ARTICLE
    // ============================================
    {
      id: "m6-final-reading-s4",
      title: "Set 4: Global Migration Report",
      category: "reading",
      passages: [
        {
          text: `GLOBAL MIGRATION TRENDS 2024
Understanding International Movement

A recent study published on August 12th, 2024, reveals fascinating trends about international migration. The research analyzed data from 195 countries and found that approximately 3.6% of the world's population (around 281 million people) live outside their country of birth.

The top destination countries are:
1. United States - 50.6 million immigrants (18% of global total)
2. Germany - 15.8 million immigrants (in the center of Europe)  
3. Saudi Arabia - 13.5 million (on the Arabian Peninsula in the Middle East)
4. United Kingdom - 9.4 million (island nation off the northwest coast of Europe)
5. Canada - 8.0 million (in the north of North America)

These five countries host nearly one third (32.5%) of all international migrants worldwide.`,
          questions: [
            {
              type: "mc",
              q: "When was the study published?",
              options: ["August 2, 2024", "August 12, 2024", "August 21, 2024"],
              a: "August 12, 2024",
              tip: "Date mentioned in first paragraph!"
            },
            {
              type: "mc",
              q: "What percentage of the world's population lives outside their birth country?",
              options: ["2.6%", "3.6%", "4.6%"],
              a: "3.6%",
              tip: "First paragraph: 'approximately 3.6%'!"
            },
            {
              type: "input",
              q: "How many countries were analyzed in the study?",
              a: ["195"],
              tip: "First paragraph mentions 195 countries!"
            },
            {
              type: "mc",
              q: "Germany is in the ___ of Europe.",
              options: ["north", "center", "south"],
              a: "center",
              tip: "List says 'in the center of Europe'!"
            }
          ]
        },
        {
          text: `AGE AND EDUCATION STATISTICS

The study found that 73.2% of international migrants are between 20 and 64 years old - approximately three quarters of all migrants. Only 13.9% are under 20 years old, and 12.9% are 65 or older.

Education levels are rising: 45% of recent migrants (those who moved in the last 5 years) have completed university education. That's nearly half of all recent migrants! This percentage has increased by 18.5% compared to migrants who moved 10 years ago.

The most common reasons for migration are:
- Work opportunities: 52.7%
- Family reunification: 26.8%  
- Education: 12.4%
- Humanitarian reasons: 8.1%

Interestingly, two thirds (66%) of migrants send money back to their home countries regularly. The global total of these remittances reached $702 billion in 2023, an increase of 3.8% from the previous year.`,
          questions: [
            {
              type: "mc",
              q: "What fraction of migrants are between 20-64 years old?",
              options: ["Two thirds", "Three quarters", "Four fifths"],
              a: "Three quarters",
              tip: "Text says 'three quarters' = 73.2%!"
            },
            {
              type: "input",
              q: "What percentage of recent migrants have university education?",
              a: ["45", "45%"],
              tip: "Education section: '45% of recent migrants'!"
            },
            {
              type: "mc",
              q: "The text says 45% is 'nearly ___.'",
              options: ["one third", "half", "two thirds"],
              a: "half",
              tip: "Text says '45%...nearly half'!"
            },
            {
              type: "mc",
              q: "What is the most common reason for migration?",
              options: ["Family reunification", "Work opportunities", "Education"],
              a: "Work opportunities",
              tip: "Work opportunities at 52.7% is highest!"
            },
            {
              type: "mc",
              q: "What fraction of migrants send money home?",
              options: ["One half", "Two thirds", "Three quarters"],
              a: "Two thirds",
              tip: "Last paragraph: 'two thirds (66%)'!"
            },
            {
              type: "input",
              q: "How do you say the decimal in 3.8%? (word for decimal point)",
              a: ["point", "Point"],
              tip: "3.8 = three point eight!"
            },
            {
              type: "mc",
              q: "Remittances reached $702 billion. How do you say this amount?",
              options: ["Seven hundred two billion", "Seven oh two billion", "Seventy-two billion"],
              a: "Seven hundred two billion",
              tip: "702 = seven hundred two!"
            },
            {
              type: "mc",
              q: "The education level increased by 18.5% compared to 10 years ago. This is a ___.",
              options: ["Decrease", "Increase", "No change"],
              a: "Increase",
              tip: "Text says 'increased by 18.5%'!"
            }
          ]
        }
      ]
    },

    // ============================================
    // SET 5: PROFESSIONAL NETWORKING
    // ============================================
    {
      id: "m6-final-reading-s5",
      title: "Set 5: Professional Network Directory",
      category: "reading",
      passages: [
        {
          text: `INTERNATIONAL PROFESSIONALS NETWORK
Connect Globally, Work Locally

MEMBER PROFILE 1: Elena Popescu
Nationality: Romanian
Current Location: Dublin, Ireland (on the east coast, by the Irish Sea)
Profession: Software Engineer, age 31
Company: Tech Solutions Europe Ltd.
Address: 67 Grafton Street, Dublin, D02 X285, Ireland
Phone: +353 1 234 5678 (country code +353, city code 1)
Mobile: +353 87 654 3210 (Irish mobile numbers start with 08)
Email: elena.popescu@techsolutions.ie
Website: www.techsolutions.ie
LinkedIn: linkedin.com/in/elena-popescu

Elena joined the network on February 14th, 2023, at 3:45 PM. She specializes in artificial intelligence and has worked in three countries: Romania, Germany, and Ireland. Her office is right next to Trinity College in the center of Dublin.`,
          questions: [
            {
              type: "input",
              q: "What is Elena's nationality?",
              a: ["Romanian", "romanian"],
              tip: "Listed at the top of her profile!"
            },
            {
              type: "mc",
              q: "Dublin is on the ___ coast of Ireland.",
              options: ["east", "west", "south"],
              a: "east",
              tip: "Location says 'east coast, by the Irish Sea'!"
            },
            {
              type: "input",
              q: "What is Elena's house/office number?",
              a: ["67"],
              tip: "Address is 67 Grafton Street!"
            },
            {
              type: "mc",
              q: "How do you say the . in Elena's website?",
              options: ["point", "dot", "period"],
              a: "dot",
              tip: "Periods in websites/emails are 'dot'!"
            }
          ]
        },
        {
          text: `MEMBER PROFILE 2: Carlos Mendoza  
Nationality: Mexican-American (dual citizenship)
Current Location: Austin, Texas, USA (south-central United States)
Profession: Marketing Director, age 28
Company: Digital Media Inc.
Address: 1550 Congress Avenue, Suite 200, Austin, TX 78701
Office: +1 512-555-9876 (five-one-two, triple five, nine-eight-seven-six)
Cell: +1 512-555-4321
Email: c.mendoza@digitalmedia.com
Personal website: www.carlosmendoza.com
Twitter: @carloscreates

Carlos joined on July 30th, 2024, at quarter past ten in the morning. He's bilingual in Spanish and English. His office is in downtown Austin, directly opposite the Texas State Capitol building. Carlos has worked with clients in 15 countries across North and South America. Office hours: Monday-Friday, 9:00 AM to 5:30 PM (Central Time).`,
          questions: [
            {
              type: "mc",
              q: "Carlos has dual citizenship. That means he's from ___ countries.",
              options: ["one", "two", "three"],
              a: "two",
              tip: "Dual = two! Mexican-American = Mexico + USA!"
            },
            {
              type: "input",
              q: "What time did Carlos join the network?",
              a: ["10:15 AM", "10:15 am", "quarter past ten", "Quarter past ten"],
              tip: "Text says 'quarter past ten' = 10:15!"
            },
            {
              type: "mc",
              q: "How do you say 555 in Carlos's phone number?",
              options: ["Five five five", "Triple five", "Both are correct"],
              a: "Both are correct",
              tip: "Text shows 'triple five' but both ways work!"
            },
            {
              type: "mc",
              q: "Carlos's office is ___ the Texas State Capitol.",
              options: ["next to", "directly opposite", "behind"],
              a: "directly opposite",
              tip: "Text says 'directly opposite'!"
            }
          ]
        },
        {
          text: `MEMBER PROFILE 3: Priya Sharma
Nationality: Indian  
Current Location: Melbourne, Australia (southeast coast, by Port Phillip Bay)
Profession: Business Consultant, age 35
Company: Global Strategy Partners
Address: Level 15, 88 Collins Street, Melbourne, VIC 3000, Australia
Office: +61 3 9876 5432 (country code +61, area code 3)
Mobile: +61 412 345 678 (Australian mobiles start with 04)
Email: priya.sharma@globalstrategy.com.au (.com.au is Australian domain)
Website: www.globalstrategy.com.au
Office hours: Monday-Thursday 8:30 AM - 5:00 PM, Friday 8:30 AM - 3:00 PM

Priya joined on December 5th, 2022, at half past two in the afternoon. She's worked in four countries on three continents: India (Asia), United Kingdom (Europe), Singapore (Asia), and Australia (Oceania). Her office building is halfway between the Yarra River and Melbourne's central business district.

Network statistics: 87.5% of members found new business opportunities through connections, and 62% attended at least one networking event in 2024. The network has grown by 145% since 2022!`,
          questions: [
            {
              type: "input",
              q: "What is Priya's nationality?",
              a: ["Indian", "indian"],
              tip: "Listed in her profile!"
            },
            {
              type: "mc",
              q: "Melbourne is on the ___ coast of Australia.",
              options: ["northeast", "southeast", "southwest"],
              a: "southeast",
              tip: "Location description says 'southeast coast'!"
            },
            {
              type: "input",
              q: "What time did Priya join the network?",
              a: ["2:30 PM", "2:30 pm", "half past two", "Half past two"],
              tip: "Text says 'half past two in the afternoon'!"
            },
            {
              type: "mc",
              q: "What does .com.au mean in Priya's email?",
              options: ["Australian domain", "Company audio", "Computer Australia"],
              a: "Australian domain",
              tip: "Text explains '.com.au is Australian domain'!"
            },
            {
              type: "mc",
              q: "Priya has worked on how many continents?",
              options: ["Two", "Three", "Four"],
              a: "Three",
              tip: "Text says 'four countries on three continents'!"
            },
            {
              type: "input",
              q: "What percentage of members found business opportunities?",
              a: ["87.5", "87.5%"],
              tip: "Statistics at the end!"
            },
            {
              type: "mc",
              q: "The network grew by 145% since 2022. This is a ___.",
              options: ["Small increase", "Large increase", "Decrease"],
              a: "Large increase",
              tip: "145% is more than double - huge growth!"
            },
            {
              type: "mc",
              q: "REFLECTION: These profiles show that professionals today ___.",
              options: ["Only work in one country", "Work internationally across borders", "Never change jobs"],
              a: "Work internationally across borders",
              tip: "All three professionals work in multiple countries!"
            }
          ]
        }
      ]
    }
  ]
};
